// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/interface/theme/stylesheet/perfectScrollbar.global.css
// module id = 1891
// module chunks = 1